import type { SVGProps } from 'react';

const SvgFrChangePerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16.5 8.14C16.5 5.31 14.19 3 11.36 3S6.22 5.31 6.22 8.14c0 1.23.45 2.35 1.18 3.23A8.3 8.3 0 0 0 3 18.72c0 .55.45 1 1 1s1-.45 1-1c0-2.69 1.67-5.03 4.16-5.95.67.32 1.41.51 2.2.51 2.83 0 5.14-2.31 5.14-5.14M11.36 5c1.73 0 3.14 1.41 3.14 3.14s-1.41 3.14-3.14 3.14-3.14-1.41-3.14-3.14S9.63 5 11.36 5m8.91 7.93c-.97-.97-2.56-.97-3.54 0l-4.24 4.24a1 1 0 0 0-.29.71V20c0 .55.45 1 1 1h2.12c.27 0 .52-.11.71-.29l4.24-4.24c.47-.47.73-1.1.73-1.77s-.26-1.3-.73-1.77m-1.42 2.12L14.9 19h-.71v-.71l3.95-3.95c.2-.19.51-.19.71 0 .13.13.15.28.15.35s-.02.23-.15.35z"
    />
  </svg>
);
export default SvgFrChangePerson;
